// fetchFreeZoneMessages.js
'use strict';
import 'isomorphic-fetch';

import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';
import objectifyArrayById from '../resource/objectifyArrayById.js';
import parseLinkHeader from 'parse-link-header';
import { getIsIos10, getIsMicrosoftEdge } from '../resource/getUserAgent.js';

import {
  ADD_MESSAGES,
  ADD_LIST_ITEMS,
  SET_LIST_ITEMS,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch free zone messages
 * @kind action
 * @param {number} [{page}] - page.
 * @param {number} [{limit}=10] - limit.
 * @return {Promise} Action promise.
 */
const fetchFreeZoneMessages =
  ({ freezoneFeed, page, limit = 30 }) =>
  async (dispatch, getState) => {
    const listSelectPath = ['freeZone', 'messages'];
    const selectPath = [...listSelectPath, page];

    const fetchOptions = {
      method: 'GET',
      headers: {
        ...getHeaders(),
      },
    };

    const url = getResourceUrl({ endpoint: `/feeds/${freezoneFeed}` });
    url.searchParams.append('limit', limit);
    if (page) {
      url.searchParams.append('page', page);
    }
    if (getIsIos10() || getIsMicrosoftEdge()) {
      url.searchParams.append('no-redirect', 1);
    }
    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });
    try {
      let response = await fetch(url.href, fetchOptions);

      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl: url,
        });
      }

      const payload = await response.json();
      const objectifyPayload = objectifyArrayById({
        array: payload.map(m => ({
          ...m,
          senderId: m.sender,
          expiresAtUnix: m.expiresAt,
          postedAtUnix: m.postedAt,
          unlockPrice: m.unlock_price,
        })),
      });
      const itemIds = Object.keys(objectifyPayload);
      const links = parseLinkHeader(response.headers.get('Link'));
      const nextPage = links && links.next && links.next.page;
      const listActionType = page === 1 ? SET_LIST_ITEMS : ADD_LIST_ITEMS;
      dispatch({ type: ADD_MESSAGES, payload: { messages: objectifyPayload } });
      dispatch({
        type: listActionType,
        payload: {
          selectPath: listSelectPath,
          itemIds,
          nextPage,
        },
      });
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default fetchFreeZoneMessages;
